import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";

export { actions, getters, mutations, state };
export default { actions, getters, mutations, state, namespaced: true };
